<template>
    <TooliabaMessage :date="date">
        <RentalInfo :isRental="true" :rental="rental" />
        <MessageSection>
            <slot></slot>
        </MessageSection>
    </TooliabaMessage> 
</template>

<script>
import TooliabaMessage from '@/components/inbox/messagesCard/shared/TooliabaMessage.vue';
import RentalInfo from '@/components/inbox/messagesCard/shared/rentalInfo/RentalInfo.vue';
import MessageSection from '@/components/inbox/messagesCard/shared/MessageSection.vue';

export default {
    components: {
        TooliabaMessage,
        RentalInfo,
        MessageSection
    },
    props: {
        rental: {
            type: Object
        },
        date: {
            type: String
        }
    }
};
</script>
